import { render } from "./ChatLoading.vue?vue&type=template&id=2ed1efc0&scoped=true"
import script from "./ChatLoading.vue?vue&type=script&lang=ts"
export * from "./ChatLoading.vue?vue&type=script&lang=ts"

import "./ChatLoading.vue?vue&type=style&index=0&id=2ed1efc0&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2ed1efc0"

export default script